import { Component, DestroyRef } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { API, ChangePasswordDTO } from 'src/app/services/api/api';
import { ModalService } from 'src/app/services/gui/modal/modal.service';
import { finalize, take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-user-profile-security',
  templateUrl: './user-profile-security.component.html',
  styleUrls: ['./user-profile-security.component.scss'],
  standalone: false,
})
export class UserProfileSecurityComponent {
  get formInvalid(): boolean {
    return (
      !(this.OldPassword.touched || this.NewPassword.touched || this.NewPasswordRepeat.touched) ||
      this.NewPassword.errors?.required ||
      this.NewPassword.errors?.required ||
      this.NewPasswordRepeat.errors?.invalid ||
      this.NewPasswordRepeat.errors?.required
    );
  }

  form = new UntypedFormGroup({
    OldPassword: new UntypedFormControl('', [Validators.required]),
    NewPassword: new UntypedFormControl('', [Validators.required]),
    NewPasswordRepeat: new UntypedFormControl('', [Validators.required, this.confirmPassword]),
  });

  get OldPassword() {
    return this.form.get('OldPassword');
  }

  get NewPassword() {
    return this.form.get('NewPassword');
  }

  get NewPasswordRepeat() {
    return this.form.get('NewPasswordRepeat');
  }

  loading: boolean;

  constructor(
    private api: API,
    private modal: ModalService,
    public translate: TranslateService,
    private destroyRef: DestroyRef
  ) {
    this.loading = false;
  }

  confirmPassword(c: AbstractControl): { invalid: boolean } {
    if (c.value !== c.parent?.controls['NewPassword'].value) {
      return { invalid: true };
    }
  }

  submit() {
    if (!this.formInvalid) {
      this.loading = true;
      const dto: ChangePasswordDTO = this.api.createDTO('ChangePasswordDTO');
      dto.oldPassword = this.OldPassword.value;
      dto.newPassword = this.NewPassword.value;
      this.api
        .shared_User_changePassword(dto)
        .pipe(
          takeUntilDestroyed(this.destroyRef),
          take(1),
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe({
          next: (res: boolean) => {
            if (res) {
              this.success();
            } else {
              this.failure();
            }
          },
          error: () => {
            this.failure();
          },
        });
    }
  }

  success() {
    this.NewPassword.reset();
    this.NewPasswordRepeat.reset();
    this.OldPassword.reset();
    this.resultModal(this.translate.instant('lang.user.passwordchange.success'), 'pwchangesuccessmodal');
  }

  failure() {
    this.resultModal(this.translate.instant('lang.user.passwordchange.failure'), 'pwchangefailedmodal');
  }

  resultModal(pTitle: string, id: string) {
    this.modal
      .modal(
        {
          title: pTitle,
          modalOptions: { windowClass: 'M' },
        },
        {
          templateId: id,
        },
        null
      )
      .then(() => {})
      .catch(() => {});
  }
}
